module.exports = __webpack_public_path__ + "5fd694e9f329217a61408de4705e69a7.jpg";